import { useState, useRef } from 'react'
import axios from "axios"
import TextInput from "./TextInput"
import TextInputBorder from "./TextInputBorder"
import Submit from "./Submit"
import InputWrapper from "./InputWrapper"
import Suggestions from './Suggestions'
import FormWrapper from "./FormWrapper"

import { redirectToSearch, stripTags } from './helpers'

type SuggRefKey = {
    count_sugg?: number
    count_sugg_tags?: number
    view_sugg: Array<{ name: string, id: number }>
    view_sugg_tags?: Array<{ name: string, id: number, link: string }>
}
// справочник для зарезолвленных асинк ответов от API
const suggRef: Record<string, SuggRefKey> = {}

const getSuggestions = (value: string) => {
    if (suggRef[value]) return Promise.resolve(suggRef[value])

	const url = 'https://www.templateroller.com/index.php?act=ajax&parametr=get_sugg_doc'
	const data = new FormData()
	data.append('q', value)

	return axios({
		method: 'post',
		url,
		data, 
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	}).then(response => {
        suggRef[value] = response.data
        return response.data
    })
}

const checkSuggestions = (sugg: Array<{ name: string, id: number }>, inputed: string) => {
    var ansver = sugg.length ? stripTags(sugg[0].name) : '';
    // true в случаях если строка в инпуте === перавой подсказке || список подсказок пуст
    return inputed === ansver || !sugg.length
}

const Search = () => {
    const [suggestions, setSuggestions] = useState<{name: string, id: number}[]>([])
    const [tags, setTags] = useState<{id: number, name: string, link: string}[]>([])
    const [hasText, setHasText] = useState(false)
    const [blurred, setBlurred] = useState(false)
    const [hoverSuggMenu, setHover] = useState(false)
    const mouseHover = (isHover: boolean) => setHover(isHover)
    const ref = useRef<HTMLInputElement>(null)

    const [selected, setSelected] = useState('')



    const doSearch = () => {
        if (!ref.current) throw Error('ref is not assigned')

        const value = ref.current.value.trim()

        if (value.length > 0) {
            redirectToSearch(stripTags(value))
        }
    }

    

    return <FormWrapper>
        <InputWrapper>
            <TextInput
                error={false}
                ref={ref}
                type="text"
                placeholder="Search for Documents"
                onChange={(event) => {
                    event.target.value.length ? setHasText(true) : setHasText(false)
                    
                    getSuggestions(event.target.value).then((data) => {
                        if (checkSuggestions(data.view_sugg, event.target.value)) {
                            setSuggestions(data['view_sugg'])
                            setTags(data['view_sugg_tags'])
                        }
                    })
                }}
                onFocus={() => setBlurred(true)}
                onBlur={() => setBlurred(false)}
                onKeyDown={(event) => {
                    switch (event.key) {
                        case 'Enter':
                            setSelected('enter')
                            break;
                        case 'ArrowDown':
                            event.preventDefault()
                            setSelected('down')
                            break;
                        case 'ArrowUp':
                            event.preventDefault()
                            setSelected('up')
                            break;
                    }
                }}
                onKeyUp={(event) => {
                    switch (event.key) {
                        case 'Enter':
                        case 'ArrowDown':
                        case 'ArrowUp':
                            setSelected('')
                            break;
                    }
                }}
            />
            <TextInputBorder
                error={false}
            ></TextInputBorder>
        </InputWrapper>

        {
            (blurred || hoverSuggMenu) && hasText &&
            <Suggestions
                suggestions={suggestions}
                tags={tags}
                isMouseHover={mouseHover}
                selectSuggestions={selected}
            />
        }

        <Submit onClick={() => doSearch()}>Search</Submit>

    </FormWrapper>
}

export default Search